// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.project-input_input_rRm8p {
    border-width: 2px;
    border-style: solid;
    border-radius: 2px;
    width: 100%;
    font-size: 23px;
    line-height: 32px;
    opacity: 0.5;
    background-color: transparent;
    color: inherit;
}

.project-input_input_rRm8p:focus {
    opacity: 1;
}

.project-input_input_rRm8p:disabled {
    opacity: 0.8;
}

.project-input_tooltip_rvZQD {
    opacity: 1 !important;
    background-color: var(--extensions-primary) !important;
    border: 1px solid var(--ui-black-transparent) !important;
    box-shadow: 0 0 .5rem var(--shadow) !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    z-index: 491 !important;
}

.project-input_tooltip_rvZQD:after {
    border-top-color: var(--extensions-primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-project-input/project-input.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,sDAAsD;IACtD,wDAAwD;IACxD,8CAA8C;IAC9C,sEAAsE;IACtE,uBAAuB;AAC3B;;AAEA;IACI,sDAAsD;AAC1D","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.input {\n    border-width: 2px;\n    border-style: solid;\n    border-radius: 2px;\n    width: 100%;\n    font-size: 23px;\n    line-height: 32px;\n    opacity: 0.5;\n    background-color: transparent;\n    color: inherit;\n}\n\n.input:focus {\n    opacity: 1;\n}\n\n.input:disabled {\n    opacity: 0.8;\n}\n\n.tooltip {\n    opacity: 1 !important;\n    background-color: var(--extensions-primary) !important;\n    border: 1px solid var(--ui-black-transparent) !important;\n    box-shadow: 0 0 .5rem var(--shadow) !important;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n    z-index: 491 !important;\n}\n\n.tooltip:after {\n    border-top-color: var(--extensions-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `project-input_input_rRm8p`,
	"tooltip": `project-input_tooltip_rvZQD`
};
export default ___CSS_LOADER_EXPORT___;
